import { render, staticRenderFns } from "./WithoutLinkSchedule.vue?vue&type=template&id=2a90f71a&scoped=true"
import script from "./WithoutLinkSchedule.vue?vue&type=script&lang=js"
export * from "./WithoutLinkSchedule.vue?vue&type=script&lang=js"
import style0 from "./WithoutLinkSchedule.vue?vue&type=style&index=0&id=2a90f71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90f71a",
  null
  
)

export default component.exports